import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ResetPasswordForm } from "@/components/reset-password-form";

const resetPasswordSearchSchema = z.object({
  error: z.string().optional(),
  token: z.string().optional(),
});

export const Route = createFileRoute("/(auth)/reset-password")({
  component: RouteComponent,
  validateSearch: resetPasswordSearchSchema.parse,
});

function RouteComponent() {
  const { error, token } = Route.useSearch();

  return <ResetPasswordForm error={error} token={token} />;
}
